import StakeContent from "./StakeContent";

export default StakeContent;
